import { BlockScrollStrategy, ComponentType, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { DialogConfig, DialogRef } from './dialog-ref';
import { DIALOG_DATA } from './dialog-tokens';
import { _getFocusedElementPierceShadowDom } from '@angular/cdk/platform';



@Injectable({
    providedIn: 'root',
})
export class DialogService {
    constructor(private overlay: Overlay, private injector: Injector) {}

    open<T>(component: ComponentType<T>, config?: DialogConfig): DialogRef {
        const elementFocusedBeforeDialogWasOpened = _getFocusedElementPierceShadowDom();

        // Globally centered position strategy
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();

        // Create the overlay with customizable options
        const overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            backdropClass: 'overlay-backdrop',
            panelClass: 'overlay-panel',
            disposeOnNavigation: true,
            scrollStrategy: this.overlay.scrollStrategies.block()
        });

        const dialogRef = new DialogRef(overlayRef, config, elementFocusedBeforeDialogWasOpened);

        if (!config?.preventCloseOnClickOutside) {
            overlayRef.backdropClick().subscribe(_ => dialogRef.close());
        }

        // Create injector to be able to reference the DialogRef from within the component
        const injector = Injector.create({
            parent: this.injector,
            providers: [
                { provide: DialogRef, useValue: dialogRef },
                { provide: DIALOG_DATA, useValue: config?.data }
            ],
        });

        // Attach component portal to the overlay
        const portal = new ComponentPortal(component, null, injector);
        overlayRef.attach(portal);

        return dialogRef;
    }
}
